import './polyfills.js';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Remove fallback overlay once React mounts
try {
  const boot = document.getElementById('boot-fallback');
  if (boot && boot.parentNode) boot.parentNode.removeChild(boot);
} catch {}

// Health check flag (selaras CONCEPT.md §9): app siap untuk monitoring/recovery
try {
  globalThis.GETFACE_HEALTH_CHECK = true;
} catch {}
